let contentUpdateCallback = null;

export function initializeDataUpdateD(callback) {
  contentUpdateCallback = callback;
}

export function initializeDataUpdateS(callback) {
  contentUpdateCallback = callback;
}

export function notifyUpdateD() {
  if (contentUpdateCallback) {
    contentUpdateCallback();
  }
}

export function notifyUpdateS() {
  if (contentUpdateCallback) {
    contentUpdateCallback();
  }
}

export function receiveUpdateD() {
  notifyUpdateD();
}
export function receiveUpdateS() {
  notifyUpdateD();
}